<mad-stepper [nextButtonLabel]="'Next'" [doneButtonLabel]="'Done'">
  <mad-step [stepControl]="this.personForm" [label]="'Person'">
    <form [formGroup]="this.personForm">
      <div class="fx fx-row fx-gap-1em fx-align-start">
        <mat-form-field>
          <mat-label>Firstname</mat-label>
          <input matInput placeholder="Firstname" formControlName="firstName" />
          <mat-error>Please enter a first name</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Lastname</mat-label>
          <input matInput placeholder="Lastname" formControlName="lastName" />
          <mat-error>Please enter a last name</mat-error>
        </mat-form-field>
      </div>
    </form>
  </mad-step>
  <mad-step [stepControl]="this.contactInformationForm" [label]="'Contact Information'">
    <form [formGroup]="this.contactInformationForm">
      <div class="fx fx-gap-1em">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput placeholder="Firstname" formControlName="email" />
          <mat-error>Please enter an email</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Phone</mat-label>
          <input matInput placeholder="Lastname" formControlName="phone" />
          <mat-error>Please enter a phone number</mat-error>
        </mat-form-field>
      </div>
    </form>
  </mad-step>
</mad-stepper>
